import React from 'react';

interface FormContainerProps {
  title?: string;
  onClose?: () => void;
}

const FormContainer: React.FC<FormContainerProps> = ({
  title,
  onClose,
  children,
}) => {
  return (
    <div className="content">
      <div className="p-8 mx-auto my-16 text-black bg-white rounded-lg  md:my-24 md:p-12">
        <div className="flex items-center justify-between mb-8">
          {title && (
            <div
              data-cy="form-container-title"
              className="text-2xl font-bold md:text-3xl"
            >
              {title}
            </div>
          )}
          {onClose && (
            <div
              className="w-10 h-10 transition-colors cursor-pointer text-body-gray hover:text-body"
              onClick={onClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default FormContainer;
